"use strict";
const redux_1 = require('redux');
const redux_thunk_1 = require('redux-thunk');
const reducer_1 = require('./reducer');
const sentryClient_1 = require('./sentryClient');
const store = redux_1.createStore(reducer_1.default, redux_1.applyMiddleware(redux_thunk_1.default, sentryClient_1.breadcrumbBuilder));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = store;



/** WEBPACK FOOTER **
 ** ./src/store.ts
 **/